export const LAYER_GROUP_DEPTH = 2
export const CAMERA_Z = 0



// WEBPACK FOOTER //
// ./three/constants/positions.js